<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-8"
        modal >
        <template #header>
            <div class="flex justify-content-between flex-wrap w-full">
                <div>
                    <span class="font-bold">Contrato</span>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button
                        v-if="form.id"
                        label="Log"
                        severity="secondary"
                        icon="pi pi-history"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        @click="openLogForm"
                        :loading="isLoading" />
                </div>
            </div>
        </template>
        
        <form @submit.prevent="onSubmit(form)">
            <Tabs class="contrato-tab-principal" v-model:value="tabIndex">
                <TabList>
                    <Tab :value="0">
                        Contrato
                    </Tab>
                    <Tab :value="1">
                        Financeiro 
                    </Tab>                    
                    <Tab :value="2" :disabled="!form.id">
                        Contas
                    </Tab>
                </TabList>
                <TabPanels>
                    <TabPanel :value="0">
                        <ScrollPanel style="height: 65vh">
                            <FormTabResumoDados :form="form" />
                        </ScrollPanel>
                    </TabPanel>
                    <TabPanel :value="1">
                        <ScrollPanel style="height: 65vh">
                            <FormTabResumoFinanceiro :form="form" :errors="errors" :permissoes="permissoes" />
                        </ScrollPanel>
                    </TabPanel>
                    <TabPanel :value="2">
                        <ScrollPanel style="height: 65vh">
                            <FormTabResumoContas v-if="form.id" :contrato="form" :permissoes="permissoes" @onOpenContaForm="openContaForm" />
                        </ScrollPanel>
                    </TabPanel> 
                </TabPanels>
            </Tabs>

            <div class="flex justify-content-between flex-wrap">
                <div class="flex justify-content-start flex-wrap gap-1">
                    <div class="text-xs">
                        <span class="text-red-500">*</span> obrigatório<br>
                    </div>
                </div>

                <div class="flex justify-content-end gap-1">
                    <Button
                        :disabled="tabIndex != 1"
                        type="submit"
                        label="Salvar"
                        severity="success"
                        icon="pi pi-save"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
                    <Button
                        label="Fechar"
                        severity="warn"
                        icon="pi pi-times"
                        size="small"
                        @click="updateVisible(false)"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
                </div>
            </div>
        </form>
        
        <LogForm :visible="visibleLogForm" table="contratos" :tableId="form.id" @close="this.visibleLogForm=false" />
    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import ScrollPanel from 'primevue/scrollpanel';
import Badge from 'primevue/badge';
import Tag from 'primevue/tag';

import Contrato from '@/service/contrato.js';
import ContratoConta from '@/service/contratoConta.js';

import FormTabResumoDados from '@/page/contrato/FormTabResumoDados.vue';
import FormTabResumoContas from '@/page/contrato/FormTabResumoContas.vue';
import FormTabResumoFinanceiro from '@/page/contrato/FormTabResumoFinanceiro.vue';

import LogForm from '@/components/LogForm.vue';

export default {
    components: { Dialog,
                  Button,
                  Tabs,
                  TabList,
                  Tab,
                  TabPanels,
                  TabPanel,
                  ScrollPanel,
                  Badge,
                  Tag,

                  /* Forms */
                  FormTabResumoDados,
                  FormTabResumoFinanceiro,
                  FormTabResumoContas,
                  LogForm,

                  /* Tabs */
                  FormTabResumoDados,
                  FormTabResumoFinanceiro,
                },
    props: {
        id: {
            type: Number,
            default: 0
        },
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {}
        },
        permissoes: {},
    },
    emits: ['save','close', 'onOpenContaForm'],
    data() {
        return {
            form: {},
            errors: {},
            msg: null,
            isLoading: false,
            pendencias: 0,

            formComfirmacao: {},
            visibleConfirmacaoForm: false,
            visibleAuthForm: false,
            visibleLogForm: false,
            tabIndex: 0,

            errors: {},
        }
    },
    methods: {
        openContaForm(conta) {
            this.$emit('onOpenContaForm', conta);
        },
        onShow() {
            if(this.id) {
                return this.loadContrato();
            }
            this.form = Contrato.parse({...this.data});
        },
        onHide() {
            this.tabIndex = 0;
            this.form = {};
        },
        openLogForm() {
            this.visibleLogForm = true;
        },
        loadForm(form) {
            this.form = Contrato.parse(form);
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        save(form) {
            if(form.id) {
                return Contrato.update(form.id,form);
            }
            return Contrato.create(form);
        },
        loadContrato() {
            this.isLoading = true;
            Contrato.get(this.id)
                .then(response => {
                    this.loadForm(response.data);
                })
                .finally(() => this.isLoading = false);
        },
        onSubmit(form) {
            this.errors = {};

            this.isLoading = true;
            ContratoConta.update(form.id, form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Seus dados foram salvos com sucesso.', life: 3000 });

                    this.form = Contrato.parse(response.data.data);

                    this.$emit('save');
                    this.$emit('close');
                })
                .catch(error => {
                    if(error.response) {
                        let err = error.response.data;
                        
                        if(err.erros && Object.getPrototypeOf(err.erros)) {
                            for(let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if(err.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: err.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    }
}
</script>

<style>
    .contrato-tab-principal .p-tabpanels {
        padding: 0;
    }
    .contrato-tab-principal .p-scrollpanel {
        padding: var(--p-tabs-tabpanel-padding);
    }
</style>
